//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
import * as Types from '../api-client.types';
import { useQuery, useMutation } from '@tanstack/react-query';
import type { UseQueryResult, QueryFunctionContext, UseQueryOptions, QueryClient, QueryKey, MutationKey, UseMutationOptions, UseMutationResult, QueryMeta, MutationMeta } from '@tanstack/react-query';
import { trimArrayEnd, isParameterObject, getBaseUrl, addMetaToOptions } from './helpers';
import type { QueryMetaContextValue } from 'react-query-swagger';
import { QueryMetaContext } from 'react-query-swagger';
import { useContext } from 'react';
import * as Client from './CmsPageClient'
export { Client };
import type { AxiosRequestConfig } from 'axios';

export type SearchCmsPageQueryParameters = {
  generalSearch?: string | null | undefined ;
  searchTitle?: string | null | undefined ;
  searchUrl?: string | null | undefined ;
  showInMenu?: boolean | null | undefined ;
  offset?: number | null | undefined ;
  limit?: number | null | undefined ;
  sortBy?: string | null | undefined ;
  sortOrder?: Types.SortOrder | undefined ;
}

export type TranslatePageCmsPageQueryParameters = {
  id: number ;
  language?: Types.Language | undefined ;
  translateTitle?: boolean | undefined ;
}

export type GetDetailsByIdCmsPageQueryParameters = {
  id: number ;
  getActiveVersion?: boolean | undefined ;
}

export type PatchByIdCmsPageQueryParameters = {
  id: number ;
  language?: Types.Language | null | undefined ;
  isAutosaved?: boolean | undefined ;
}

export type DeleteByIdCmsPageQueryParameters = {
  id: number ;
}

export type GetDetailsByUrlCmsPageQueryParameters = {
  url: string ;
  getActiveVersion?: boolean | undefined ;
}

export function searchUrl(generalSearch?: string | null | undefined, searchTitle?: string | null | undefined, searchUrl?: string | null | undefined, showInMenu?: boolean | null | undefined, offset?: number | null | undefined, limit?: number | null | undefined, sortBy?: string | null | undefined, sortOrder?: Types.SortOrder | undefined): string {
  let url_ = getBaseUrl() + "/api/cms-pages?";
if (generalSearch !== undefined && generalSearch !== null)
    url_ += "GeneralSearch=" + encodeURIComponent("" + generalSearch) + "&";
if (searchTitle !== undefined && searchTitle !== null)
    url_ += "SearchTitle=" + encodeURIComponent("" + searchTitle) + "&";
if (searchUrl !== undefined && searchUrl !== null)
    url_ += "SearchUrl=" + encodeURIComponent("" + searchUrl) + "&";
if (showInMenu !== undefined && showInMenu !== null)
    url_ += "ShowInMenu=" + encodeURIComponent("" + showInMenu) + "&";
if (offset !== undefined && offset !== null)
    url_ += "Offset=" + encodeURIComponent("" + offset) + "&";
if (limit !== undefined && limit !== null)
    url_ += "Limit=" + encodeURIComponent("" + limit) + "&";
if (sortBy !== undefined && sortBy !== null)
    url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
if (sortOrder === null)
    throw new Error("The parameter 'sortOrder' cannot be null.");
else if (sortOrder !== undefined)
    url_ += "SortOrder=" + encodeURIComponent("" + sortOrder) + "&";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let searchDefaultOptions: Omit<UseQueryOptions<Types.PagedResultOfCmsPageListItemDto, unknown, Types.PagedResultOfCmsPageListItemDto>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.PagedResultOfCmsPageListItemDto, unknown, Types.PagedResultOfCmsPageListItemDto>, 'queryFn'>> = {
};
export function getSearchDefaultOptions() {
  return searchDefaultOptions;
};
export function setSearchDefaultOptions(options: typeof searchDefaultOptions) {
  searchDefaultOptions = options;
}

export function searchQueryKey(dto: SearchCmsPageQueryParameters): QueryKey;
export function searchQueryKey(generalSearch?: string | null | undefined, searchTitle?: string | null | undefined, searchUrl?: string | null | undefined, showInMenu?: boolean | null | undefined, offset?: number | null | undefined, limit?: number | null | undefined, sortBy?: string | null | undefined, sortOrder?: Types.SortOrder | undefined): QueryKey;
export function searchQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { generalSearch, searchTitle, searchUrl, showInMenu, offset, limit, sortBy, sortOrder,  } = params[0] as SearchCmsPageQueryParameters;

    return trimArrayEnd([
        'CmsPageClient',
        'search',
        generalSearch as any,
        searchTitle as any,
        searchUrl as any,
        showInMenu as any,
        offset as any,
        limit as any,
        sortBy as any,
        sortOrder as any,
      ]);
  } else {
    return trimArrayEnd([
        'CmsPageClient',
        'search',
        ...params
      ]);
  }
}
export function __search(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.search(
      context.queryKey[2] as string | null | undefined,       context.queryKey[3] as string | null | undefined,       context.queryKey[4] as string | null | undefined,       context.queryKey[5] as boolean | null | undefined,       context.queryKey[6] as number | null | undefined,       context.queryKey[7] as number | null | undefined,       context.queryKey[8] as string | null | undefined,       context.queryKey[9] as Types.SortOrder | undefined,axiosConfig    );
}

export function useSearchQuery<TSelectData = Types.PagedResultOfCmsPageListItemDto, TError = unknown>(dto: SearchCmsPageQueryParameters, options?: Omit<UseQueryOptions<Types.PagedResultOfCmsPageListItemDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
/**
 * Searches CmsPages.
 * @param generalSearch (optional) Substring must be in title or url
 * @param searchTitle (optional) 
 * @param searchUrl (optional) 
 * @param showInMenu (optional) 
 * @param offset (optional) Offset of list.
 * @param limit (optional) Number of requested records.
 * @param sortBy (optional) Field name for sorting in DB (ABAS).
 * @param sortOrder (optional) Sort direction. Ascending or Descending.
 */
export function useSearchQuery<TSelectData = Types.PagedResultOfCmsPageListItemDto, TError = unknown>(generalSearch?: string | null | undefined, searchTitle?: string | null | undefined, searchUrl?: string | null | undefined, showInMenu?: boolean | null | undefined, offset?: number | null | undefined, limit?: number | null | undefined, sortBy?: string | null | undefined, sortOrder?: Types.SortOrder | undefined, options?: Omit<UseQueryOptions<Types.PagedResultOfCmsPageListItemDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useSearchQuery<TSelectData = Types.PagedResultOfCmsPageListItemDto, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.PagedResultOfCmsPageListItemDto, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  let generalSearch: any = undefined;
  let searchTitle: any = undefined;
  let searchUrl: any = undefined;
  let showInMenu: any = undefined;
  let offset: any = undefined;
  let limit: any = undefined;
  let sortBy: any = undefined;
  let sortOrder: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ generalSearch, searchTitle, searchUrl, showInMenu, offset, limit, sortBy, sortOrder,  } = params[0] as SearchCmsPageQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [generalSearch, searchTitle, searchUrl, showInMenu, offset, limit, sortBy, sortOrder, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.PagedResultOfCmsPageListItemDto, TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __search(context, axiosConfig) : __search,
    queryKey: searchQueryKey(generalSearch, searchTitle, searchUrl, showInMenu, offset, limit, sortBy, sortOrder),
    ...searchDefaultOptions as unknown as Omit<UseQueryOptions<Types.PagedResultOfCmsPageListItemDto, TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}
/**
 * Searches CmsPages.
 * @param generalSearch (optional) Substring must be in title or url
 * @param searchTitle (optional) 
 * @param searchUrl (optional) 
 * @param showInMenu (optional) 
 * @param offset (optional) Offset of list.
 * @param limit (optional) Number of requested records.
 * @param sortBy (optional) Field name for sorting in DB (ABAS).
 * @param sortOrder (optional) Sort direction. Ascending or Descending.
 */
export function setSearchData(queryClient: QueryClient, updater: (data: Types.PagedResultOfCmsPageListItemDto | undefined) => Types.PagedResultOfCmsPageListItemDto, generalSearch?: string | null | undefined, searchTitle?: string | null | undefined, searchUrl?: string | null | undefined, showInMenu?: boolean | null | undefined, offset?: number | null | undefined, limit?: number | null | undefined, sortBy?: string | null | undefined, sortOrder?: Types.SortOrder | undefined) {
  queryClient.setQueryData(searchQueryKey(generalSearch, searchTitle, searchUrl, showInMenu, offset, limit, sortBy, sortOrder),
    updater
  );
}

/**
 * Searches CmsPages.
 * @param generalSearch (optional) Substring must be in title or url
 * @param searchTitle (optional) 
 * @param searchUrl (optional) 
 * @param showInMenu (optional) 
 * @param offset (optional) Offset of list.
 * @param limit (optional) Number of requested records.
 * @param sortBy (optional) Field name for sorting in DB (ABAS).
 * @param sortOrder (optional) Sort direction. Ascending or Descending.
 */
export function setSearchDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.PagedResultOfCmsPageListItemDto | undefined) => Types.PagedResultOfCmsPageListItemDto) {
  queryClient.setQueryData(queryKey, updater);
}
    
export function createUrl(): string {
  let url_ = getBaseUrl() + "/api/cms-pages";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function createMutationKey(): MutationKey {
  return trimArrayEnd([
      'CmsPageClient',
      'create',
    ]);
}

/**
 * Creates CmsPage.
 */
export function useCreateMutation<TContext>(options?: Omit<UseMutationOptions<Types.CmsPageDto, unknown, Types.CreateCmsPageDto, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<Types.CmsPageDto, unknown, Types.CreateCmsPageDto, TContext> {
  const key = createMutationKey();
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: (createCmsPageDto: Types.CreateCmsPageDto) => Client.create(createCmsPageDto),
    mutationKey: key,
  });
}
  
export function translatePageUrl(id: number, language?: Types.Language | undefined, translateTitle?: boolean | undefined): string {
  let url_ = getBaseUrl() + "/api/cms-pages/{id}/translate?";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
if (language === null)
    throw new Error("The parameter 'language' cannot be null.");
else if (language !== undefined)
    url_ += "language=" + encodeURIComponent("" + language) + "&";
if (translateTitle === null)
    throw new Error("The parameter 'translateTitle' cannot be null.");
else if (translateTitle !== undefined)
    url_ += "translateTitle=" + encodeURIComponent("" + translateTitle) + "&";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function translatePageMutationKey(id: number, language?: Types.Language | undefined, translateTitle?: boolean | undefined): MutationKey {
  return trimArrayEnd([
      'CmsPageClient',
      'translatePage',
      id as any,
      language as any,
      translateTitle as any,
    ]);
}

/**
 * Performs translate action for page.
 * @param language (optional) 
 * @param translateTitle (optional) 
 */
export function useTranslatePageMutation<TContext>(id: number, language?: Types.Language | undefined, translateTitle?: boolean | undefined, options?: Omit<UseMutationOptions<Types.CmsPageDto, unknown, string, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<Types.CmsPageDto, unknown, string, TContext> {
  const key = translatePageMutationKey(id, language, translateTitle);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: (content: string) => Client.translatePage(id, content, language, translateTitle),
    mutationKey: key,
  });
}
  
type TranslatePage__MutationParameters = TranslatePageCmsPageQueryParameters & {
  content: string;
}

/**
 * Performs translate action for page.
 * @param language (optional) 
 * @param translateTitle (optional) 
 */
export function useTranslatePageMutationWithParameters<TContext>(options?: Omit<UseMutationOptions<Types.CmsPageDto, unknown, TranslatePage__MutationParameters, TContext>, 'mutationKey' | 'mutationFn'> & { parameters?: TranslatePageCmsPageQueryParameters}): UseMutationResult<Types.CmsPageDto, unknown, TranslatePage__MutationParameters, TContext> {
  const key = translatePageMutationKey(options?.parameters?.id!, options?.parameters?.language!, options?.parameters?.translateTitle!);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
return useMutation({
  ...options, 
  mutationFn: (data: TranslatePage__MutationParameters) => Client.translatePage(data.id ?? options?.parameters?.id!, data.content, data.language ?? options?.parameters?.language!, data.translateTitle ?? options?.parameters?.translateTitle!),
  mutationKey: key,
});
}
  
export function getDetailsByIdUrl(id: number, getActiveVersion?: boolean | undefined): string {
  let url_ = getBaseUrl() + "/api/cms-pages/id/{id}?";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
if (getActiveVersion === null)
    throw new Error("The parameter 'getActiveVersion' cannot be null.");
else if (getActiveVersion !== undefined)
    url_ += "getActiveVersion=" + encodeURIComponent("" + getActiveVersion) + "&";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let getDetailsByIdDefaultOptions: Omit<UseQueryOptions<Types.CmsPageDto, unknown, Types.CmsPageDto>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.CmsPageDto, unknown, Types.CmsPageDto>, 'queryFn'>> = {
};
export function getGetDetailsByIdDefaultOptions() {
  return getDetailsByIdDefaultOptions;
};
export function setGetDetailsByIdDefaultOptions(options: typeof getDetailsByIdDefaultOptions) {
  getDetailsByIdDefaultOptions = options;
}

export function getDetailsByIdQueryKey(dto: GetDetailsByIdCmsPageQueryParameters): QueryKey;
export function getDetailsByIdQueryKey(id: number, getActiveVersion?: boolean | undefined): QueryKey;
export function getDetailsByIdQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { id, getActiveVersion,  } = params[0] as GetDetailsByIdCmsPageQueryParameters;

    return trimArrayEnd([
        'CmsPageClient',
        'getDetailsById',
        id as any,
        getActiveVersion as any,
      ]);
  } else {
    return trimArrayEnd([
        'CmsPageClient',
        'getDetailsById',
        ...params
      ]);
  }
}
export function __getDetailsById(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.getDetailsById(
      context.queryKey[2] as number,       context.queryKey[3] as boolean | undefined,axiosConfig    );
}

export function useGetDetailsByIdQuery<TSelectData = Types.CmsPageDto, TError = unknown>(dto: GetDetailsByIdCmsPageQueryParameters, options?: Omit<UseQueryOptions<Types.CmsPageDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
/**
 * Gets CMS page details by id.
 * @param getActiveVersion (optional) If true, returns the latest (active) version
If false, returns the published version of the page
Default: false.
 */
export function useGetDetailsByIdQuery<TSelectData = Types.CmsPageDto, TError = unknown>(id: number, getActiveVersion?: boolean | undefined, options?: Omit<UseQueryOptions<Types.CmsPageDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useGetDetailsByIdQuery<TSelectData = Types.CmsPageDto, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.CmsPageDto, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  let id: any = undefined;
  let getActiveVersion: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ id, getActiveVersion,  } = params[0] as GetDetailsByIdCmsPageQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [id, getActiveVersion, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.CmsPageDto, TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __getDetailsById(context, axiosConfig) : __getDetailsById,
    queryKey: getDetailsByIdQueryKey(id, getActiveVersion),
    ...getDetailsByIdDefaultOptions as unknown as Omit<UseQueryOptions<Types.CmsPageDto, TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}
/**
 * Gets CMS page details by id.
 * @param getActiveVersion (optional) If true, returns the latest (active) version
If false, returns the published version of the page
Default: false.
 */
export function setGetDetailsByIdData(queryClient: QueryClient, updater: (data: Types.CmsPageDto | undefined) => Types.CmsPageDto, id: number, getActiveVersion?: boolean | undefined) {
  queryClient.setQueryData(getDetailsByIdQueryKey(id, getActiveVersion),
    updater
  );
}

/**
 * Gets CMS page details by id.
 * @param getActiveVersion (optional) If true, returns the latest (active) version
If false, returns the published version of the page
Default: false.
 */
export function setGetDetailsByIdDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.CmsPageDto | undefined) => Types.CmsPageDto) {
  queryClient.setQueryData(queryKey, updater);
}
    
export function patchByIdUrl(id: number, language?: Types.Language | null | undefined, isAutosaved?: boolean | undefined): string {
  let url_ = getBaseUrl() + "/api/cms-pages/id/{id}?";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
if (language !== undefined && language !== null)
    url_ += "language=" + encodeURIComponent("" + language) + "&";
if (isAutosaved === null)
    throw new Error("The parameter 'isAutosaved' cannot be null.");
else if (isAutosaved !== undefined)
    url_ += "isAutosaved=" + encodeURIComponent("" + isAutosaved) + "&";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function patchByIdMutationKey(id: number, language?: Types.Language | null | undefined, isAutosaved?: boolean | undefined): MutationKey {
  return trimArrayEnd([
      'CmsPageClient',
      'patchById',
      id as any,
      language as any,
      isAutosaved as any,
    ]);
}

/**
 * Patch By Id.
 * @param language (optional) 
 * @param isAutosaved (optional) 
 */
export function usePatchByIdMutation<TContext>(id: number, language?: Types.Language | null | undefined, isAutosaved?: boolean | undefined, options?: Omit<UseMutationOptions<Types.CmsPageDto, unknown, Types.PatchCmsPageDto, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<Types.CmsPageDto, unknown, Types.PatchCmsPageDto, TContext> {
  const key = patchByIdMutationKey(id, language, isAutosaved);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: (patchCmsPageDto: Types.PatchCmsPageDto) => Client.patchById(id, patchCmsPageDto, language, isAutosaved),
    mutationKey: key,
  });
}
  
type PatchById__MutationParameters = PatchByIdCmsPageQueryParameters & {
  patchCmsPageDto: Types.PatchCmsPageDto;
}

/**
 * Patch By Id.
 * @param language (optional) 
 * @param isAutosaved (optional) 
 */
export function usePatchByIdMutationWithParameters<TContext>(options?: Omit<UseMutationOptions<Types.CmsPageDto, unknown, PatchById__MutationParameters, TContext>, 'mutationKey' | 'mutationFn'> & { parameters?: PatchByIdCmsPageQueryParameters}): UseMutationResult<Types.CmsPageDto, unknown, PatchById__MutationParameters, TContext> {
  const key = patchByIdMutationKey(options?.parameters?.id!, options?.parameters?.language!, options?.parameters?.isAutosaved!);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
return useMutation({
  ...options, 
  mutationFn: (data: PatchById__MutationParameters) => Client.patchById(data.id ?? options?.parameters?.id!, data.patchCmsPageDto, data.language ?? options?.parameters?.language!, data.isAutosaved ?? options?.parameters?.isAutosaved!),
  mutationKey: key,
});
}
  
export function deleteByIdUrl(id: number): string {
  let url_ = getBaseUrl() + "/api/cms-pages/id/{id}";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function deleteByIdMutationKey(id: number): MutationKey {
  return trimArrayEnd([
      'CmsPageClient',
      'deleteById',
      id as any,
    ]);
}

/**
 * Delete By Id.
 */
export function useDeleteByIdMutation<TContext>(id: number, options?: Omit<UseMutationOptions<void, unknown, void, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, void, TContext> {
  const key = deleteByIdMutationKey(id);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: () => Client.deleteById(id),
    mutationKey: key,
  });
}
  
type DeleteById__MutationParameters = DeleteByIdCmsPageQueryParameters

/**
 * Delete By Id.
 */
export function useDeleteByIdMutationWithParameters<TContext>(options?: Omit<UseMutationOptions<void, unknown, DeleteById__MutationParameters, TContext>, 'mutationKey' | 'mutationFn'> & { parameters?: DeleteByIdCmsPageQueryParameters}): UseMutationResult<void, unknown, DeleteById__MutationParameters, TContext> {
  const key = deleteByIdMutationKey(options?.parameters?.id!);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
return useMutation({
  ...options, 
  mutationFn: (data: DeleteById__MutationParameters) => Client.deleteById(data.id ?? options?.parameters?.id!),
  mutationKey: key,
});
}
  
export function getInaccessiblePublishedUrlsUrl(): string {
  let url_ = getBaseUrl() + "/api/cms-pages/inaccessible-urls";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let getInaccessiblePublishedUrlsDefaultOptions: Omit<UseQueryOptions<string[], unknown, string[]>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<string[], unknown, string[]>, 'queryFn'>> = {
};
export function getGetInaccessiblePublishedUrlsDefaultOptions() {
  return getInaccessiblePublishedUrlsDefaultOptions;
};
export function setGetInaccessiblePublishedUrlsDefaultOptions(options: typeof getInaccessiblePublishedUrlsDefaultOptions) {
  getInaccessiblePublishedUrlsDefaultOptions = options;
}

export function getInaccessiblePublishedUrlsQueryKey(): QueryKey;
export function getInaccessiblePublishedUrlsQueryKey(...params: any[]): QueryKey {
  return trimArrayEnd([
      'CmsPageClient',
      'getInaccessiblePublishedUrls',
    ]);
}
export function __getInaccessiblePublishedUrls(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.getInaccessiblePublishedUrls(
axiosConfig    );
}

/**
 * Get Inaccessible Published Urls.
 */
export function useGetInaccessiblePublishedUrlsQuery<TSelectData = string[], TError = unknown>(options?: Omit<UseQueryOptions<string[], TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useGetInaccessiblePublishedUrlsQuery<TSelectData = string[], TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<string[], TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  

  options = params[0] as any;
  axiosConfig = params[1] as any;

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<string[], TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __getInaccessiblePublishedUrls(context, axiosConfig) : __getInaccessiblePublishedUrls,
    queryKey: getInaccessiblePublishedUrlsQueryKey(),
    ...getInaccessiblePublishedUrlsDefaultOptions as unknown as Omit<UseQueryOptions<string[], TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}
/**
 * Get Inaccessible Published Urls.
 */
export function setGetInaccessiblePublishedUrlsData(queryClient: QueryClient, updater: (data: string[] | undefined) => string[], ) {
  queryClient.setQueryData(getInaccessiblePublishedUrlsQueryKey(),
    updater
  );
}

/**
 * Get Inaccessible Published Urls.
 */
export function setGetInaccessiblePublishedUrlsDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: string[] | undefined) => string[]) {
  queryClient.setQueryData(queryKey, updater);
}
    
export function getDetailsByUrlUrl(url: string, getActiveVersion?: boolean | undefined): string {
  let url_ = getBaseUrl() + "/api/cms-pages/{url}?";
if (url === undefined || url === null)
  throw new Error("The parameter 'url' must be defined.");
url_ = url_.replace("{url}", encodeURIComponent("" + url));
if (getActiveVersion === null)
    throw new Error("The parameter 'getActiveVersion' cannot be null.");
else if (getActiveVersion !== undefined)
    url_ += "getActiveVersion=" + encodeURIComponent("" + getActiveVersion) + "&";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let getDetailsByUrlDefaultOptions: Omit<UseQueryOptions<Types.CmsPageDto, unknown, Types.CmsPageDto>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.CmsPageDto, unknown, Types.CmsPageDto>, 'queryFn'>> = {
};
export function getGetDetailsByUrlDefaultOptions() {
  return getDetailsByUrlDefaultOptions;
};
export function setGetDetailsByUrlDefaultOptions(options: typeof getDetailsByUrlDefaultOptions) {
  getDetailsByUrlDefaultOptions = options;
}

export function getDetailsByUrlQueryKey(dto: GetDetailsByUrlCmsPageQueryParameters): QueryKey;
export function getDetailsByUrlQueryKey(url: string, getActiveVersion?: boolean | undefined): QueryKey;
export function getDetailsByUrlQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { url, getActiveVersion,  } = params[0] as GetDetailsByUrlCmsPageQueryParameters;

    return trimArrayEnd([
        'CmsPageClient',
        'getDetailsByUrl',
        url as any,
        getActiveVersion as any,
      ]);
  } else {
    return trimArrayEnd([
        'CmsPageClient',
        'getDetailsByUrl',
        ...params
      ]);
  }
}
export function __getDetailsByUrl(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.getDetailsByUrl(
      context.queryKey[2] as string,       context.queryKey[3] as boolean | undefined,axiosConfig    );
}

export function useGetDetailsByUrlQuery<TSelectData = Types.CmsPageDto, TError = unknown>(dto: GetDetailsByUrlCmsPageQueryParameters, options?: Omit<UseQueryOptions<Types.CmsPageDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
/**
 * Gets CMS page details by URL.
 * @param getActiveVersion (optional) If true, returns the latest (active) version
If false, returns the published version of the page
Default: false.
 */
export function useGetDetailsByUrlQuery<TSelectData = Types.CmsPageDto, TError = unknown>(url: string, getActiveVersion?: boolean | undefined, options?: Omit<UseQueryOptions<Types.CmsPageDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useGetDetailsByUrlQuery<TSelectData = Types.CmsPageDto, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.CmsPageDto, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  let url: any = undefined;
  let getActiveVersion: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ url, getActiveVersion,  } = params[0] as GetDetailsByUrlCmsPageQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [url, getActiveVersion, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.CmsPageDto, TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __getDetailsByUrl(context, axiosConfig) : __getDetailsByUrl,
    queryKey: getDetailsByUrlQueryKey(url, getActiveVersion),
    ...getDetailsByUrlDefaultOptions as unknown as Omit<UseQueryOptions<Types.CmsPageDto, TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}
/**
 * Gets CMS page details by URL.
 * @param getActiveVersion (optional) If true, returns the latest (active) version
If false, returns the published version of the page
Default: false.
 */
export function setGetDetailsByUrlData(queryClient: QueryClient, updater: (data: Types.CmsPageDto | undefined) => Types.CmsPageDto, url: string, getActiveVersion?: boolean | undefined) {
  queryClient.setQueryData(getDetailsByUrlQueryKey(url, getActiveVersion),
    updater
  );
}

/**
 * Gets CMS page details by URL.
 * @param getActiveVersion (optional) If true, returns the latest (active) version
If false, returns the published version of the page
Default: false.
 */
export function setGetDetailsByUrlDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.CmsPageDto | undefined) => Types.CmsPageDto) {
  queryClient.setQueryData(queryKey, updater);
}